import { Cancel } from "@mui/icons-material";
import { Timestamp } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { useEffect, useState } from "react";
import { storage } from "./Backend";


const Overview = () => {

    const[adminName,setAdminname]=useState("");
    const[adminEmail,setAdminemail]=useState("");
    const[adminLocation,setAdminlocation]=useState("");
    // const[lastSeen,setLastseen]=useState("");
    const[profile,setProfile]=useState(false);
    const[imageselected,setImageselected]=useState();
    const[photoCopyImage,setPhotecopy]=useState();
    const[success,setSuccessMessage]=useState(false);
    const now = Timestamp.now();
    const datejoined = new Date(now?.toDate()).toUTCString();


    const handleSaveImage=()=>{

        if(imageselected){
            const storageref = ref(storage,'profilepics/'+datejoined);
            const uploadImage = uploadBytesResumable(storageref,imageselected);
            uploadImage.on(
              (error)=>{
                console.log(error);
              },
              ()=>{
                getDownloadURL(uploadImage.snapshot.ref).then(async(downloadUrl)=>{
                   localStorage.setItem("profilepic",downloadUrl)
                //    setPhotecopy(localStorage.getItem("profilepic"));
                //    setAdminemail(localStorage.getItem("user_id"));
                //    setAdminname(localStorage.getItem("name_id"));
                //    setAdminlocation(localStorage.getItem("location_id"));
                //    setProfile(true);
                })
                .catch((error)=>{
                   console.log(error);
                });
              }
            )
        }
    };

    useEffect(()=>{
        const name = localStorage.getItem("user_id");
        const myLocation = localStorage.getItem("location_id");
        const picture = localStorage.getItem("profilepic");
        const userID = localStorage.getItem("user_id");
        if(name){
            setAdminname(name);
            setProfile(true);
        }
        if(myLocation){
            setAdminlocation(myLocation);
        }
        if(picture){
            setPhotecopy(picture);
        }
        if(userID){
            setAdminemail(userID);
        }
    },[]);


    return ( 
        <div className="overview">
       
        {
            !imageselected && !profile &&
            <div className="admin-profile">
            <input id="profilepic" type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>setImageselected(e.target.files[0])}/>
            <label htmlFor="profilepic">
            <svg style={{cursor:"pointer"}}
                viewBox="0 0 24 24"
                fill="currentColor"
                height="400px"
                width="400px" >
                <path d="M12 2A10.13 10.13 0 002 12a10 10 0 004 7.92V20h.1a9.7 9.7 0 0011.8 0h.1v-.08A10 10 0 0022 12 10.13 10.13 0 0012 2zM8.07 18.93A3 3 0 0111 16.57h2a3 3 0 012.93 2.36 7.75 7.75 0 01-7.86 0zm9.54-1.29A5 5 0 0013 14.57h-2a5 5 0 00-4.61 3.07A8 8 0 014 12a8.1 8.1 0 018-8 8.1 8.1 0 018 8 8 8 0 01-2.39 5.64z" />
                <path d="M12 6a3.91 3.91 0 00-4 4 3.91 3.91 0 004 4 3.91 3.91 0 004-4 3.91 3.91 0 00-4-4zm0 6a1.91 1.91 0 01-2-2 1.91 1.91 0 012-2 1.91 1.91 0 012 2 1.91 1.91 0 01-2 2z" />
            </svg>
            </label>
            <h2 style={{color:"#0B65DA",fontFamily:"fantasy"}}>Click on the User Logo to upload your photo</h2>
            </div>
        }
        
        {
            imageselected && 
            <div className="admin-profile">
             <img 
             style={{
                width:"400px",
                borderRadius:"50%"
                }}
             src={URL.createObjectURL(imageselected)} 
             alt="admin profile" />
                <h3 style={{color:"#0B65DA"}}>Change Profile</h3>
                <input id="profilepic" type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>setImageselected(e.target.files[0])}/>
                <label htmlFor="profilepic">
                <svg style={{cursor:"pointer"}}
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    height="3rem"
                    width="3rem" >
                    <path d="M12 2A10.13 10.13 0 002 12a10 10 0 004 7.92V20h.1a9.7 9.7 0 0011.8 0h.1v-.08A10 10 0 0022 12 10.13 10.13 0 0012 2zM8.07 18.93A3 3 0 0111 16.57h2a3 3 0 012.93 2.36 7.75 7.75 0 01-7.86 0zm9.54-1.29A5 5 0 0013 14.57h-2a5 5 0 00-4.61 3.07A8 8 0 014 12a8.1 8.1 0 018-8 8.1 8.1 0 018 8 8 8 0 01-2.39 5.64z" />
                    <path d="M12 6a3.91 3.91 0 00-4 4 3.91 3.91 0 004 4 3.91 3.91 0 004-4 3.91 3.91 0 00-4-4zm0 6a1.91 1.91 0 01-2-2 1.91 1.91 0 012-2 1.91 1.91 0 012 2 1.91 1.91 0 01-2 2z" />
                 </svg>
                </label>
              <button onClick={handleSaveImage} style={{
                position:"absolute",
                right:"25%",
                bottom:"4rem",
                cursor:"pointer",
                backgroundColor:"#0B65DA",
                fontSize:"1rem",
                fontWeight:"bold",
                border:"none",
                borderRadius:"10px",
                padding:"10px",
                color:"white"
                }}>
                Save Image
                </button>
            </div>  
        }

        {
            !imageselected && profile &&
            <div className="admin-profile">
                <img 
                style={{
                width:"400px",
                borderRadius:"50%"
                }}
                src={photoCopyImage} 
                alt="admin profile" />
                <h3 style={{color:"#0B65DA"}}>Change Profile</h3>
                <input id="profilepic" type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>setImageselected(e.target.files[0])}/>
                <label htmlFor="profilepic">
                <svg style={{cursor:"pointer"}}
                viewBox="0 0 24 24"
                fill="currentColor"
                height="3rem"
                width="3rem" >
                <path d="M12 2A10.13 10.13 0 002 12a10 10 0 004 7.92V20h.1a9.7 9.7 0 0011.8 0h.1v-.08A10 10 0 0022 12 10.13 10.13 0 0012 2zM8.07 18.93A3 3 0 0111 16.57h2a3 3 0 012.93 2.36 7.75 7.75 0 01-7.86 0zm9.54-1.29A5 5 0 0013 14.57h-2a5 5 0 00-4.61 3.07A8 8 0 014 12a8.1 8.1 0 018-8 8.1 8.1 0 018 8 8 8 0 01-2.39 5.64z" />
                <path d="M12 6a3.91 3.91 0 00-4 4 3.91 3.91 0 004 4 3.91 3.91 0 004-4 3.91 3.91 0 00-4-4zm0 6a1.91 1.91 0 01-2-2 1.91 1.91 0 012-2 1.91 1.91 0 012 2 1.91 1.91 0 01-2 2z" />
                 </svg>
                </label>
            </div>
        }

        {
            profile&&
            <div className="admin-profile">
                <h2>{adminName}</h2>
                <h3>{adminEmail}</h3>
                <h3>{adminLocation}</h3>
                {/* <h4 style={{color:"orangered"}}><strong>Last Visit</strong>: last seen</h4> */}
            </div>
        }
        {
            !profile&&
            <div className="admin-profile">
                <h2>Admin name:-----------</h2>
                <h3>Admin Contact/Email:------</h3>
                <h3>Your Unit/Chapter:--------</h3>
                <h4 style={{color:"orangered"}}>Set up your profile to display your personal details in the empty fields</h4>
            </div>
        }
        {
        success &&
        <div className="toast">
            <h2 style={{color:"white",fontWeight:"bold"}}>Image Saved for {adminName}</h2> 
            <button onClick={()=>setSuccessMessage(false)}><Cancel/></button>
        </div>
        }
       
        
        </div>
     );
}
 
export default Overview;